<script>
export default {
  name: 'ItineraryPricesPriceSettingsHotelModal',
  props: {
    hotels: {
      type: Array,
      required: false,
    },
    index: {
      type: Number,
      required: true,
    },
    hotelIndex: {
      type: Number,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
    priceSettings: {
      type: Object,
      default: () => {},
    },
    site: {
      type: Object,
      default: () => {},
    },
    accommodation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hotelModal: false,
      rooms: [],
      selectedSite: {
        hotel: null,
        room: null,
      },
      disableSave: false,
    };
  },
  watch: {
    site(value) {
      if (value) {
        const selectedHotel = this.hotels.find(hotel => hotel.siteId === this.site.id);
        selectedHotel && this.setHotel(this.hotels.find(hotel => hotel.siteId === this.site.id));
      }
    },
    accommodation(value) {
      if (value) {
        this.selectedSite.room = this.accommodation;
      }
    },
  },
  created() {
    if (this.site && this.hotels.length) {
      const selectedHotel = this.hotels.find(hotel => hotel.siteId === this.site.id);
      selectedHotel && this.setHotel(this.hotels.find(hotel => hotel.siteId === this.site.id));
    }
    if (this.accommodation) {
      this.selectedSite.room = this.accommodation;
    }
  },
  methods: {
    setHotel(value) {
      this.selectedSite.hotel = value;
      this.rooms = value.accommodationSites.map(e => ({
        ...e.accommodation,
        accommodationSiteId: e.id,
        name: e.accommodation.name.concat(' (', e.accommodation.maxAges.join(', ').replace(/999/g, 'A'), ')'),
      }));
    },
    setRoom(value) {
      this.selectedSite.room = value;
    },
    setSite() {
      this.$emit('update', this.selectedSite);
      this.hotelModal = false;
    },
    checkForRoomAvailability() {
      if (this.priceSettings) {
        const siteAccommodationsInUse = this.priceSettings.hotels.filter((hotel, index) => {
          if (this.hotelIndex !== index) {
            if (hotel.accommodation) {
              return hotel.accommodation.id;
            }
            return null;
          }
          return null;
        });
        const mappedSiteAccommodationsInUse = siteAccommodationsInUse.map(e => e.accommodation.id);
        if (siteAccommodationsInUse.length) {
          if (this.selectedSite.room && this.selectedSite.room) {
            if (mappedSiteAccommodationsInUse.includes(this.selectedSite.room.id)) {
              this.disableSave = true;
              return 'The same hotel and room are already in use - choose a different room or hotel';
            }
            this.disableSave = false;
            return true;
          }
        }
      }
      this.disableSave = false;
      return true;
    },
  },
};
</script>

<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="hotelModal"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :disabled="!hotels.length"
          color="deep-orange"
          flat
          icon
          v-on="on"
        >
          <v-icon>hotel</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Day {{ index + 1 }} | {{ date }}
        </v-card-title>
        <v-container>
          <v-layout column>
            <v-flex class="mb-2">
              <h3>Select hotel</h3>
            </v-flex>
            <v-flex>
              <v-select
                @input="setHotel"
                :value="selectedSite.hotel"
                :items="hotels"
                item-value="name"
                item-text="name"
                hide-details
                return-object
                solo
              />
            </v-flex>
            <v-flex class="mb-2 mt-5">
              <h3>Select room</h3>
            </v-flex>
            <v-flex>
              <v-select
                @input="setRoom"
                :value="selectedSite.room"
                :rules="[checkForRoomAvailability]"
                :items="rooms"
                item-value="id"
                item-text="name"
                return-object
                solo
              />
            </v-flex>
          </v-layout>
        </v-container>

        <v-divider />

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="setSite" color="deep-orange" :disabled="disableSave">
            Set hotel & room
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesPriceSettingsHotelModal.vue